<template>
  <div v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-6">
          <div class="vx-col w-full mb-2">
            <vs-button
              @click="createCollection()"
              class="bg_l_green"
              v-has-permission="permission173"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("CreateNewCollection") }}
            </vs-button>
          </div>
        </div>
        <modify-popup
          :show="ModifyPopup"
          @finish="onfinish"
          @close="closeModifyPopup"
        ></modify-popup>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('CollectionName'), sort: 'CollectionName' },
                { title: $t('Priority'), sort: 'Priority' },
                { title: $t('Position'), sort: 'Position' },
                { title: $t('CreateOn'), sort: 'CreateOn' },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 30%">
                  {{ row.name }}
                </td>
                <td style="width: 12%">
                  {{ row.priority }}
                </td>
                <td style="width: 15%">
                  {{ row.position }}
                </td>
                <td style="width: 15%; direction: ltr">
                  {{ row.createOn.split(" ")[0] }}<br />{{
                    row.createOn.split(" ")[1]
                  }}
                </td>
                <td style="width: 24%">
                  <router-link
                    :to="{ path: '/ProductCollection/Management/' + row.id }"
                  >
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="simple-bordered-btn"
                      v-has-permission="permission249"
                      >{{ $t("Management") }}</vs-button
                    >
                  </router-link>
                  <vs-button
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    @click.prevent="deleteCollection(row.id)"
                    class="d-inline"
                    v-has-permission="permission174"
                  ></vs-button>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import ModifyPopup from "./ModifyPopup.vue";
export default {
  name: "Content_management_ProductCollection_Index",
  components: {
    ModifyPopup,
    DataGrid,
  },
  data() {
    return {
      permission173: "CreateProductCollection",
      permission174: "DeleteProductCollection",
      permission249:
        "UnAssignProductsFromProductCollection|AssignProducts|ModifyProductCollection",

      ModifyPopup: false,
      gridDataSource: {
        type: "app",
        service: "CMS/api/ProductCollectionQuery",
      },
      gridSearchData: {
        keyword: "",
      },
    };
  },
  methods: {
    ...mapActions({
      removeCollection: "productCollection/remove",
    }),
    createCollection() {
      this.ModifyPopup = true;
    },
    //Delete Method
    deleteCollection(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeCollection(id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    closeModifyPopup() {
      this.ModifyPopup = false;
    },
    onfinish() {
      this.closeModifyPopup();
      this.$refs.grid.renderGrid();
    },
  },
};
</script>
